(() => {
  const fitments = [
    ['BMW','3 Series','E36','1990','2000',['316i (M40 / M43)','318i (M40 / M43)','318is (M42 / M44)','318ti Compact (M42 / M44)','320i (M50 / M52)','323i (M52)','323ti Compact (M52)','325i (M50)','328i (M52)','318tds (M41)','325td (M51)','325tds (M51)','M3 3.0 (S50B30)','M3 Evolution 3.2 (S50B32)']],
    ['BMW','3 Series','E46','1998','2006',['316i','318i','320i','323i','325i','328i','330i','318d','320d','330d','M3 (S54B32)']],
    ['BMW','3 Series','E90 / E91 / E92 / E93','2005','2013',['316i','318i','320i','323i','325i','328i','330i','335i N54','335i N55','316d','318d','320d','325d','330d','335d','M3 (S65B40)']],
    ['BMW','3 Series','F30 / F31 / F34','2012','2019',['316i','318i','320i','328i','330i','335i','340i','316d','318d','320d','325d','330d','335d','320d xDrive','330d xDrive','335d xDrive']],
    ['BMW','3 Series','G20 / G21','2019','Present',['318i','320i','330i','M340i','320e','330e','318d','320d','330d']],
    ['BMW','1 Series','E81 / E82 / E87 / E88','2004','2013',['116i','118i','120i','125i','130i','135i N54','135i N55','116d','118d','120d','123d','1M N54']],
    ['BMW','1 Series','F20 / F21','2011','2019',['114i','116i','118i','120i','125i','M135i','M140i','114d','116d','118d','120d','125d']],
    ['BMW','1 Series','F40','2019','Present',['116i','118i','120i','128ti','M135i xDrive','116d','118d','120d']],
    ['BMW','5 Series','E39','1995','2004',['520i','523i','525i','528i','530i','535i','540i','520d','525d','530d','M5 S62']],
    ['BMW','5 Series','E60 / E61','2003','2010',['520i','523i','525i','530i','535i','545i','550i','520d','525d','530d','535d','M5 S85']],
    ['BMW','5 Series','F10 / F11','2010','2017',['520i','528i','530i','535i','550i','518d','520d','525d','530d','535d','M5 S63']],
    ['BMW','X5','E53','1999','2006',['3.0i','4.4i','4.6is','4.8is','3.0d']],
    ['BMW','X5','E70','2007','2013',['30i','35i','48i','50i','30d','35d','40d','M S63']],
    ['BMW','Z4','E85 / E86','2002','2008',['2.0i','2.2i','2.5i','3.0i','3.0si','M S54']],
    ['MINI','Hatch','R50 / R53','2001','2006',['One','Cooper','Cooper S','JCW']],
    ['MINI','Hatch','R56','2006','2013',['One','Cooper','Cooper S N14','Cooper S N18','JCW N14','JCW N18','Cooper D','Cooper SD']],
    ['MINI','Hatch','F56','2014','2024',['One','Cooper','Cooper S','JCW','Cooper D','Cooper SD','Electric']],
    ['MINI','Countryman','R60','2010','2016',['One','Cooper','Cooper S','JCW','Cooper D','Cooper SD']],
    ['MINI','Countryman','F60','2017','2024',['Cooper','Cooper S','JCW','Cooper D','Cooper SD','Cooper SE']],
    ['AUDI','A3','8P','2003','2013',['1.2 TFSI','1.4 TFSI','1.6','1.8 TFSI','2.0 TFSI','S3','RS3','1.6 TDI','1.9 TDI','2.0 TDI']],
    ['AUDI','A3','8V','2012','2020',['1.0 TFSI','1.2 TFSI','1.4 TFSI','1.5 TFSI','1.8 TFSI','2.0 TFSI','S3','RS3','1.6 TDI','2.0 TDI']],
    ['AUDI','A3','8Y','2020','Present',['30 TFSI','35 TFSI','40 TFSI e','S3','RS3','30 TDI','35 TDI','40 TDI']],
    ['AUDI','A4','B7','2004','2008',['1.6','1.8T','2.0 TFSI','3.2 FSI','S4','RS4','1.9 TDI','2.0 TDI','2.5 TDI','3.0 TDI']],
    ['AUDI','A4','B8','2008','2016',['1.8 TFSI','2.0 TFSI','3.0 TFSI','S4','RS4','2.0 TDI','2.7 TDI','3.0 TDI']],
    ['AUDI','A4','B9','2016','Present',['35 TFSI','40 TFSI','45 TFSI','S4','RS4','30 TDI','35 TDI','40 TDI','45 TDI','50 TDI']],
    ['AUDI','TT','8J','2006','2014',['1.8 TFSI','2.0 TFSI','3.2 VR6','TTS','TT RS','2.0 TDI']],
    ['AUDI','TT','8S','2014','2023',['1.8 TFSI','2.0 TFSI','TTS','TT RS','2.0 TDI']],
    ['VOLKSWAGEN','Golf','Mk4','1997','2004',['1.4','1.6','1.8T','2.0','V5','V6 4Motion','R32','1.9 SDI','1.9 TDI']],
    ['VOLKSWAGEN','Golf','Mk5','2004','2009',['1.4','1.4 TSI','1.6 FSI','2.0 FSI','GTI','R32','1.9 TDI','2.0 TDI']],
    ['VOLKSWAGEN','Golf','Mk6','2009','2014',['1.2 TSI','1.4 TSI','GTI','Golf R','1.6 TDI','2.0 TDI','GTD']],
    ['VOLKSWAGEN','Golf','Mk7 / Mk7.5','2013','2020',['1.0 TSI','1.2 TSI','1.4 TSI','1.5 TSI','GTI','Golf R','1.6 TDI','2.0 TDI','GTD','GTE','e-Golf']],
    ['VOLKSWAGEN','Golf','Mk8','2020','Present',['1.0 TSI','1.5 TSI','GTI','Clubsport','Golf R','2.0 TDI','GTD','GTE','eHybrid']],
    ['VOLKSWAGEN','Transporter','T5 / T5.1','2003','2015',['1.9 TDI','2.0 TDI','2.5 TDI','2.0 BiTDI','2.0 petrol','3.2 VR6']],
    ['VOLKSWAGEN','Transporter','T6 / T6.1','2015','2024',['2.0 TDI','2.0 BiTDI','2.0 TSI','eHybrid']],
    ['MERCEDES-BENZ','A-Class','W176','2012','2018',['A160','A180','A200','A220','A250','A250 4MATIC','A45 AMG','A180d','A200d','A220d']],
    ['MERCEDES-BENZ','A-Class','W177','2018','Present',['A180','A200','A220','A250','A35 AMG','A45 S AMG','A180d','A200d','A220d','A250e']],
    ['MERCEDES-BENZ','C-Class','W203','2000','2007',['C180','C200','C230','C240','C280','C320','C32 AMG','C55 AMG','C200 CDI','C220 CDI','C270 CDI','C320 CDI']],
    ['MERCEDES-BENZ','C-Class','W204','2007','2014',['C180','C200','C250','C280','C300','C350','C63 AMG','C200 CDI','C220 CDI','C250 CDI','C320 CDI','C350 CDI']],
    ['MERCEDES-BENZ','C-Class','W205','2014','2021',['C180','C200','C250','C300','C350e','C43 AMG','C63 AMG','C200d','C220d','C250d','C300d']],
    ['MERCEDES-BENZ','Sprinter','W906','2006','2018',['209 CDI','211 CDI','213 CDI','215 CDI','216 CDI','309 CDI','311 CDI','313 CDI','315 CDI','316 CDI','318 CDI','319 CDI']],
    ['MERCEDES-BENZ','Sprinter','W907 / W910','2018','Present',['211 CDI','214 CDI','215 CDI','216 CDI','311 CDI','314 CDI','315 CDI','316 CDI','317 CDI','319 CDI']],
    ['CUPRA / SEAT','Leon','1P','2005','2012',['1.2 TSI','1.4 TSI','1.6','1.8 TSI','2.0 TFSI FR','Cupra','Cupra R','1.6 TDI','1.9 TDI','2.0 TDI']],
    ['CUPRA / SEAT','Leon','5F','2012','2020',['1.0 TSI','1.2 TSI','1.4 TSI','1.5 TSI','1.8 TSI','Cupra','1.6 TDI','2.0 TDI']],
    ['CUPRA / SEAT','Leon','KL','2020','Present',['1.0 TSI','1.5 TSI','2.0 TSI','eHybrid','Cupra 245','Cupra 300','1.6 TDI','2.0 TDI']],
    ['CUPRA / SEAT','Formentor','KM7','2020','Present',['1.5 TSI','2.0 TSI 190','VZ2 310','VZ3 310','VZ5 390','eHybrid 204','eHybrid 245','2.0 TDI']],
    ['ŠKODA','Octavia','1Z Mk2','2004','2013',['1.2 TSI','1.4 TSI','1.6 FSI','1.8 TSI','2.0 FSI','vRS 2.0 TFSI','1.6 TDI','1.9 TDI','2.0 TDI','vRS 2.0 TDI']],
    ['ŠKODA','Octavia','5E Mk3','2013','2020',['1.0 TSI','1.2 TSI','1.4 TSI','1.5 TSI','1.8 TSI','vRS 2.0 TSI','1.6 TDI','2.0 TDI','vRS 2.0 TDI']],
    ['ŠKODA','Octavia','NX Mk4','2020','Present',['1.0 TSI','1.5 TSI','2.0 TSI','vRS 2.0 TSI','iV','vRS iV','2.0 TDI','2.0 TSI AWD Combi','2.0 TDI AWD Combi']]
  ];

  fitments.push(
    ["BMW", "2 Series", "F22", "2014", "2019", ["220i", "228i", "230i", "M235i", "M240i", "218d", "220d"]],
    ["BMW", "2 Series", "G42", "2021", "Present", ["M240i xDrive"]],
    ["BMW", "4 Series", "F32 / F36", "2014", "2019", ["420i", "428i", "430i", "435i", "440i", "420d", "430d", "435d"]],
    ["BMW", "3 Series", "F80", "2014", "2018", ["M3 (S55B30)"]],
    ["BMW", "3 Series", "G80", "2021", "Present", ["M3 (S58B30 RWD)", "M3 Competition xDrive (S58B30)"]],
    ["BMW", "M2", "F87", "2016", "2021", ["M2 N55", "M2 Competition S55"]],
    ["BMW", "M2", "G87", "2023", "Present", ["M2 S58"]],
    ["BMW", "M3", "E36", "1992", "1999", ["S50B30", "S50B32"]],
    ["BMW", "M3", "E46", "2001", "2006", ["S54B32"]],
    ["BMW", "M3", "E90 / E92 / E93", "2007", "2013", ["S65B40"]],
    ["BMW", "M3", "F80", "2014", "2018", ["S55B30"]],
    ["BMW", "M3", "G80", "2021", "Present", ["S58B30 RWD", "S58B30 Competition xDrive"]],
    ["BMW", "M4", "G82", "2021", "Present", ["M4 S58 RWD", "M4 Competition xDrive"]],
    ["BMW", "5 Series", "G30", "2017", "2023", ["520i RWD", "530i RWD", "540i RWD", "520d RWD", "530d RWD"]],
    ["BMW", "8 Series", "G16", "2018", "Present", ["840i RWD"]],
    ["AUDI", "A5", "B8", "2007", "2016", ["1.8 TFSI", "2.0 TFSI", "3.0 TFSI", "2.0 TDI", "3.0 TDI"]],
    ["AUDI", "A5", "F5", "2016", "Present", ["35 TFSI", "40 TFSI", "45 TFSI", "35 TDI", "40 TDI"]],
    ["AUDI", "TT", "8N", "1999", "2006", ["1.8T FWD", "1.8T quattro", "3.2 quattro"]],
    ["VOLKSWAGEN", "Scirocco", "PQ35", "2009", "2017", ["1.4 TSI", "2.0 TSI", "2.0 TDI", "Scirocco R"]],
    ["VOLKSWAGEN", "Polo", "AW", "2018", "Present", ["1.0 TSI", "1.5 TSI", "1.6 TDI", "GTI"]],
    ["VOLKSWAGEN", "Touran", "5T", "2015", "Present", ["1.2 TSI", "1.4 TSI", "1.5 TSI", "1.6 TDI", "2.0 TDI"]],
    ["VOLKSWAGEN", "ID. Buzz", "LWB", "2023", "Present", ["Electric LWB RWD"]],
    ["VOLKSWAGEN", "Tiguan", "CT1", "2024", "Present", ["2.0 TSI AWD", "2.0 TDI AWD"]],
    ["MERCEDES-BENZ", "CLA-Class", "C117", "2013", "2019", ["CLA180", "CLA200", "CLA250", "CLA200 CDI", "CLA220 CDI"]],
    ["MERCEDES-BENZ", "C-Class", "C205", "2015", "2021", ["C63 S AMG"]],
    ["MERCEDES-BENZ", "E-Class", "W213 / C238", "2017", "2023", ["E200", "E300", "E350", "E400", "E220d", "E300d", "E350d"]],
    ["MERCEDES-BENZ", "GLA", "H247", "2020", "Present", ["GLA 250 4MATIC", "GLA 35 4MATIC", "GLA 45 4MATIC"]],
    ["MINI", "Clubman", "F54", "2014", "2023", ["Cooper FWD", "Cooper S FWD", "Cooper D FWD", "Cooper SD FWD"]],
    ["PORSCHE", "Cayman", "987", "2005", "2012", ["2.7", "2.9", "S 3.4", "R 3.4"]],
    ["PORSCHE", "Boxster", "987", "2005", "2012", ["2.7", "2.9", "S 3.4"]],
    ["PORSCHE", "Cayman", "981", "2013", "2016", ["2.7", "S 3.4", "GTS 3.4"]],
    ["PORSCHE", "Cayman", "718 / 982", "2016", "Present", ["718", "718 S", "718 GTS"]],
    ["PORSCHE", "Boxster", "718 / 982", "2016", "Present", ["718", "718 S", "718 GTS"]],
    ["PORSCHE", "911", "991", "2011", "2016", ["Carrera RWD", "Carrera S RWD", "Carrera GTS RWD"]],
    ["PORSCHE", "911", "992", "2019", "Present", ["Carrera RWD", "Carrera S RWD", "Carrera GTS RWD"]],
    ["ŠKODA", "Superb", "3T", "2008", "2015", ["1.4 TSI", "1.8 TSI", "2.0 TSI", "1.6 TDI", "2.0 TDI"]],
    ["ŠKODA", "Superb", "B8", "2015", "2023", ["2.0 TSI 4x4", "2.0 TDI 4x4"]]
  );

  fitments.push(
    ['BMW','M4','F82 / F83','2014','2020',['S55B30']],
    ['BMW','4 Series','G22 / G23 / G26','2020','Present',['M440i B58']],
    ['BMW','Z4','E89','2009','2016',['sDrive35i N54','sDrive35is N54']],
    ['AUDI','Q3','8U','2011','2018',['2.0 TFSI']],
    ['CUPRA / SEAT','Ibiza','6J','2008','2017',['1.2 TSI','1.4 TSI']]
  );
  for(const row of fitments){
    const [make,model,generation]=row;
    if(make==='BMW' && generation==='F40')row[4]='2024';
    if(make==='BMW' && model==='2 Series' && generation==='F22')row[4]='2021';
    if(make==='MINI' && generation==='F54')row[3]='2015';
    if(make==='VOLKSWAGEN' && model==='Golf'){
      if(generation==='Mk5')row[3]='2003';
      if(generation==='Mk6'){row[3]='2008';row[4]='2013';}
      if(generation==='Mk7 / Mk7.5')row[3]='2012';
    }
    if(make==='ŠKODA' && model==='Superb' && generation==='B8')row[5]=['1.4 TSI','1.8 TSI','2.0 TSI','2.0 TSI 4x4','1.6 TDI','2.0 TDI','2.0 TDI 4x4'];
  }
  const performanceModels={A3:['S3','RS3'],A4:['S4','RS4'],TT:['TTS','TT RS']};
  for(const row of [...fitments]){
    if(row[0]!=='AUDI' || !performanceModels[row[1]])continue;
    for(const model of performanceModels[row[1]])if(row[5].includes(model))fitments.push(['AUDI',model,row[2],row[3],row[4],[model]]);
  }
  const $ = (id) => document.getElementById(id);
  const els = { make: $('bhMake'), model: $('bhModel'), generation: $('bhGeneration'), body: $('bhBody'), year: $('bhYear'), engine: $('bhEngine') };
  if (!els.make) return;

  const unique = (values) => [...new Set(values)];
  const fill = (select, values, prompt) => {
    select.replaceChildren();
    select.append(new Option(prompt,''));
    for(const value of values){
      let label=value;
      if(select===els.engine && els.make.value==='VOLKSWAGEN' && els.model.value==='Golf'){
        if(value==='GTI')label=els.generation.value==='Mk5'?'GTI — 2.0 TFSI (EA113)':'GTI — 2.0 TSI';
        if(value==='Golf R')label=els.generation.value==='Mk6'?'Golf R — 2.0 TFSI (EA113)':'Golf R — 2.0 TSI';
      }
      if(select===els.generation && els.make.value==='BMW'){
        if(value==='F22')label='F22 / F23';
        if(value==='F32 / F36')label='F32 / F33 / F36';
      }
      select.append(new Option(label,value));
    }
    select.disabled = values.length === 0;
  };
  const matching = () => fitments.filter(f => (!els.make.value || f[0] === els.make.value) && (!els.model.value || f[1] === els.model.value) && (!els.generation.value || f[2] === els.generation.value));
  const yearsFor = (rows) => {
    const current = new Date().getFullYear();
    const years = [];
    rows.forEach(r => {
      const end = r[4] === 'Present' ? current : Number(r[4]);
      for (let y = Number(r[3]); y <= end; y += 1) years.push(String(y));
    });
    return unique(years).filter(year=>enginesFor(Number(year)).length).sort((a,b) => Number(b) - Number(a));
  };
  const engineAllowed=(engine,year)=>{
    const make=els.make.value,model=els.model.value,generation=els.generation.value,body=els.body.value;
    let range=[0,9999];
    if(make==='BMW'){
      if(generation==='F20 / F21' && engine==='M140i')range=[2016,2019];
      if(generation==='F20 / F21' && engine==='M135i')range=[2012,2016];
      if(generation==='F22' && ['M240i','230i'].includes(engine))range=[2016,2021];
      if(generation==='F22' && ['M235i','228i'].includes(engine))range=[2014,2016];
      if(generation==='F87')range=engine.includes('Competition')?[2018,2021]:[2016,2018];
      if(generation==='E89' && engine==='sDrive35is N54')range=[2010,2016];
      if(generation==='F30 / F31 / F34' && ['340i','330i','318i'].includes(engine))range=[2015,2019];
      if(generation==='F30 / F31 / F34' && ['335i','328i'].includes(engine))range=[2012,2015];
      if(generation==='F32 / F36' && ['440i','430i'].includes(engine))range=[2016,2019];
      if(generation==='F32 / F36' && ['435i','428i'].includes(engine))range=[2014,2016];
      if(generation==='E90 / E91 / E92 / E93'){
        if(engine==='335i N54')range=[2006,2010];
        if(engine==='335i N55')range=[2010,2013];
        if(engine.includes('M3')){range=[2007,2013];if(body==='Touring')return false;}
      }
      if(generation==='E81 / E82 / E87 / E88'){
        if(engine==='135i N54')range=[2007,2010];
        if(engine==='135i N55')range=[2010,2013];
        if(engine==='1M N54')range=[2011,2012];
      }
      if(model==='3 Series' && generation==='E46' && engine.includes('M3')){
        range=[2001,2006];if(body && !['Coupe','Convertible'].includes(body))return false;
      }
      if(model==='3 Series' && generation==='E36' && engine.startsWith('M3')){
        range=engine.includes('3.0')?[1992,1995]:[1995,1999];if(['Touring','Hatchback'].includes(body))return false;
      }
      if(model==='M3' && generation==='E36')range=engine==='S50B30'?[1992,1995]:[1995,1999];
      if(generation==='F10 / F11' && engine==='M5 S63'){range=[2011,2016];if(body==='Touring')return false;}
    }
    if(make==='AUDI'){
      if(generation==='8P' && engine==='RS3'){range=[2011,2012];if(body && body!=='Hatchback')return false;}
      if(generation==='8P' && engine==='S3'){range=[2006,2012];if(body && body!=='Hatchback')return false;}
      if(generation==='8P' && engine==='1.2 TFSI')range=[2010,2013];
      if(generation==='8P' && engine==='1.4 TFSI')range=[2007,2013];
      if(generation==='8P' && engine==='1.6 TDI')range=[2009,2013];
      if(generation==='8P' && engine==='1.8 TFSI')range=[2007,2013];
      if(generation==='8V' && engine==='RS3')range=[2015,2020];
      if(generation==='8Y' && engine==='RS3')range=[2021,2026];
      if(generation==='B7' && engine==='RS4')range=[2006,2008];
      if(generation==='B8' && engine==='S4')range=[2009,2016];
      if(generation==='B8' && engine==='RS4'){range=[2012,2015];if(body && body!=='Touring')return false;}
      if(generation==='8J' && engine==='TT RS')range=[2009,2014];
      if(generation==='8S' && engine==='TT RS')range=[2016,2023];
    }
    if(make==='VOLKSWAGEN' && model==='Golf'){
      if(generation==='Mk5'){
        if(body==='Hatchback' && year>2008)return false;
        if(body==='Touring' && year<2007)return false;
      }
      if(generation==='Mk6'){
        if(body==='Hatchback' && year>2012)return false;
        if(body==='Touring' && year<2009)return false;
        if(['GTI','Golf R','GTD'].includes(engine)){range=[2009,2012];if(body==='Touring')return false;}
      }
      if(generation==='Mk7 / Mk7.5' && body==='Touring' && year<2013)return false;
    }
    return year>=range[0] && year<=range[1];
  };
  const enginesFor=year=>unique(matching().flatMap(row=>row[5])).filter(engine=>engineAllowed(engine,year));
  fill(els.make, unique(fitments.map(f => f[0])), 'Choose manufacturer');
  fill(els.model, [], 'Choose model');
  fill(els.body, [], 'Choose body style');
  fill(els.generation, [], 'Choose generation');
  fill(els.year, [], 'Choose year');
  fill(els.engine, [], 'Choose engine');

  const bodyStyles=()=>{
    const make=els.make.value, model=els.model.value, generation=els.generation.value;
    if(!generation)return [];
    if(make==='BMW' && model==='3 Series'){
      if(generation==='E90 / E91 / E92 / E93')return ['Saloon','Touring','Coupe','Convertible'];
      if(generation==='F80' || generation==='G80')return ['Saloon'];
      if(generation==='F30 / F31 / F34')return ['Saloon','Touring','Hatchback'];
      if(generation==='G20 / G21')return ['Saloon','Touring'];
      return ['Saloon','Touring','Coupe','Convertible','Hatchback'];
    }
    if(make==='BMW' && model==='2 Series')return generation==='G42'?['Coupe']:['Coupe','Convertible'];
    if(make==='BMW' && model==='4 Series')return ['Coupe','Convertible','Saloon'];
    if(make==='BMW' && model==='M2')return ['Coupe'];
    if(make==='BMW' && model==='M3'){
      if(generation==='E36')return ['Saloon','Coupe','Convertible'];
      if(generation==='E46')return ['Coupe','Convertible'];
      if(generation==='E90 / E92 / E93')return ['Saloon','Coupe','Convertible'];
      return ['Saloon'];
    }
    if(make==='BMW' && model==='M4')return generation==='G82'?['Coupe']:['Coupe','Convertible'];
    if(make==='BMW' && model==='Z4')return generation==='E89'?['Convertible']:['Convertible','Coupe'];
    if(make==='BMW' && model==='5 Series')return ['Saloon','Touring'];
    if(make==='BMW' && model==='8 Series')return ['Saloon'];
    if(make==='MINI' && model==='Hatch')return ['Hatchback'];
    if(make==='AUDI' && model==='A3')return generation==='8P'?['Hatchback','Convertible']:['Hatchback','Saloon'];
    if(make==='AUDI' && ['S3','RS3'].includes(model))return generation==='8P'?['Hatchback']:['Hatchback','Saloon'];
    if(make==='AUDI' && ['S4','RS4'].includes(model))return model==='RS4' && ['B8','B9'].includes(generation)?['Touring']:['Saloon','Touring'];
    if(make==='AUDI' && ['TTS','TT RS'].includes(model))return ['Coupe','Convertible'];
    if(make==='AUDI' && model==='A4')return ['Saloon','Touring'];
    if(make==='AUDI' && model==='A5')return ['Coupe','Convertible','Saloon'];
    if(make==='AUDI' && model==='TT')return ['Coupe','Convertible'];
    if(make==='VOLKSWAGEN' && model==='Golf')return ['Hatchback','Touring'];
    if(make==='VOLKSWAGEN' && model==='Polo')return ['Hatchback'];
    if(make==='VOLKSWAGEN' && model==='Scirocco')return ['Coupe'];
    if(make==='MERCEDES-BENZ' && model==='C-Class')return generation==='C205'?['Coupe']:generation==='W205'?['Saloon','Touring']:['Saloon','Touring','Coupe'];
    if(make==='MERCEDES-BENZ' && model==='E-Class')return ['Saloon','Touring','Coupe','Convertible'];
    if(make==='MERCEDES-BENZ' && model==='CLA-Class')return ['Saloon','Touring'];
    if(make==='MERCEDES-BENZ' && model==='A-Class')return generation==='W176'?['Hatchback']:['Hatchback','Saloon'];
    if(make==='CUPRA / SEAT' && model==='Leon')return generation==='1P'?['Hatchback']:['Hatchback','Touring'];
    if(make==='CUPRA / SEAT' && model==='Ibiza')return ['Hatchback','Touring'];
    if(make==='ŠKODA' && ['Octavia','Superb'].includes(model))return ['Saloon','Touring'];
    if(make==='PORSCHE' && model==='Cayman')return ['Coupe'];
    if(make==='PORSCHE' && model==='911')return ['Coupe','Convertible'];
    if(make==='PORSCHE' && model==='Boxster')return ['Convertible'];
    return []; // Vans and SUVs do not need a car body style field.
  };
  const updateBody=()=>{
    const styles=bodyStyles();
    $('bhBodyWrap').hidden=styles.length===0;
    fill(els.body, styles, 'Choose body style');
  };
  els.make.addEventListener('change', () => {
    els.model.value=''; els.generation.value='';
    fill(els.model, unique(matching().map(f => f[1])), 'Choose model');
    fill(els.generation, [], 'Choose generation'); fill(els.year, [], 'Choose year'); fill(els.engine, [], 'Choose engine');
    updateBody();
  });
  els.model.addEventListener('change', () => {
    els.generation.value='';
    fill(els.generation, unique(matching().map(f => f[2])), 'Choose generation');
    fill(els.year, [], 'Choose year'); fill(els.engine, [], 'Choose engine');
    updateBody();
  });
  els.generation.addEventListener('change', () => {
    updateBody();
    const rows = matching();
    fill(els.year, yearsFor(rows), 'Choose year');
    fill(els.engine, [], 'Choose engine');
  });
  const updateEngines=()=>{
    const previous=els.engine.value;
    const engines=els.year.value?enginesFor(Number(els.year.value)):[];
    fill(els.engine,engines,'Choose engine');
    if(engines.includes(previous))els.engine.value=previous;
  };
  els.year.addEventListener('change',updateEngines);
  els.body.addEventListener('change',()=>{
    const year=els.year.value;
    const years=yearsFor(matching());
    fill(els.year,years,'Choose year');
    if(years.includes(year))els.year.value=year;
    updateEngines();
  });

  // Older versions remembered a vehicle indefinitely. Remove that stale value so
  // the finder always opens ready for a fresh selection.
  localStorage.removeItem('blackhandVehicle');
  let saved;
  try { saved=JSON.parse(sessionStorage.getItem('blackhandVehicle')||'null'); } catch (_) {}
  if(saved){
    for(const key of ['make','model','generation','body','year','engine']){
      const select=els[key];
      if(saved[key] && [...select.options].some(option=>option.value===saved[key])){
        select.value=saved[key];select.dispatchEvent(new Event('change'));
      }
    }
  }

  document.querySelectorAll('[data-bh-make]').forEach(link => link.addEventListener('click', (event) => {
    event.preventDefault();
    els.make.value = link.dataset.bhMake;
    els.make.dispatchEvent(new Event('change'));
    els.model.focus();
    document.querySelector('.bh-finder')?.scrollIntoView({behavior:'smooth',block:'center'});
  }));

  $('bhFindParts').addEventListener('click', () => {
    const vehicle = Object.fromEntries(Object.entries(els).map(([key, el]) => [key, el.value]));
    if (Object.entries(vehicle).some(([key,value]) => !value && (key!=='body' || !els.body.disabled))) { $('bhFinderStatus').textContent = 'Please complete every vehicle field.'; return; }
    if(!enginesFor(Number(vehicle.year)).includes(vehicle.engine)){ $('bhFinderStatus').textContent='Please check the year and engine selection.'; return; }
    try {sessionStorage.setItem('blackhandVehicle', JSON.stringify(vehicle));} catch (_) {}
    const label = `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.generation} ${vehicle.engine}`;
    $('bhFinderStatus').textContent = `Loading parts categories for ${label}…`;
    window.location.href = '/pages/vehicle-parts?'+new URLSearchParams(vehicle).toString();
  });
})();
